export default "__VITE_ASSET__f2778b5c__"